<template>
    <div>
      <div class="list">
        <router-link to="/employee/relations/enrollment" tag="a"  class="link"  active-class = "active">
          离职管理
        </router-link>
        <!-- <router-link to="/employee/relations/probation" tag="a"  class="link" active-class = "active">
          转正管理
        </router-link>
        <router-link to="/employee/relations/departure" tag="a"  class="link" active-class = "active">
          离职管理
        </router-link> -->
      </div>
      <!-- <keep-alive> -->
        <router-view/>
      <!-- </keep-alive> -->
    </div>

</template>

<script>
    export default {
        name: "header-list"
    }
</script>

<style scoped>
  .list{    text-align: center;
    border-bottom: 1px solid #e9eaec;
    position: relative;margin-bottom: 20px;}
  .list .link{    font-size: 16px;
    margin: 0 20px;
    color: #495060;
    line-height: 60px;
    height: 60px;
    cursor: pointer;
    display: inline-block;}
  .list .link.active{    color: #0bb27a;
    border-bottom: 2px solid #0bb27a;}
</style>



// WEBPACK FOOTER //
// src/view/employee/relations/relationsMenu.vue